import script from "./DrivingSafetyTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DrivingSafetyTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DrivingSafetyTemplate.vue?vue&type=style&index=0&id=0ed4fc1c&lang=scss"

const __exports__ = script;

export default __exports__